import { createFeatureSelector, createSelector } from '@ngrx/store';
import { UsersState } from '../reducers/users.reducer';

export const userState: any = createFeatureSelector<UsersState>('users');

export const usersData = createSelector(userState, (state: any) => {
  return state.data;
});
export const usersSearchData = createSelector(userState, (state: any) => {
  return state.searchData;
});

export const userSidData = createSelector(userState, (state: any) => {
  return state.sidUserData;
});
export const userAppData = createSelector(userState, (state: any) => {
  return state.sidAppData;
});

export const usersLoader = createSelector(userState, (state: any) => {
  return state.loader;
});
export const searchText = createSelector(userState, (state: any) => state.searchText);
